import api from './api';

export interface Family {
  id: string;
  name: string;
  created_at: string;
  updated_at?: string;
}

export const familyService = {
  getFamilies: async (): Promise<Family[]> => {
    const response = await api.get('/api/families');
    return response.data.families;
  },
  addFamily: async (name: string): Promise<Family> => {
    const response = await api.post('/api/families', { name });
    return response.data;
  },
  updateFamily: async (id: string, name: string): Promise<Family> => {
    const response = await api.patch(`/api/families/${id}`, { name });
    return response.data;
  },
  deleteFamily: async (id: string): Promise<{ id: string }> => {
    const response = await api.delete(`/api/families/${id}`);
    return response.data;
  }
}; 